import { SERVICE, TEAM } from '@otto-ec/eprivacy-shared'
import {
  createMeasureServiceFor,
  MeasureType,
} from '@otto-ec/eprivacy-measures'

export const measureInit = createMeasureServiceFor(
  MeasureType.Init,
  TEAM,
  SERVICE
)
